import React from 'react';
import useAppContext from './utilities/use-app-context';
import './style.css';
import { useHistory } from "react-router-dom";

function ErrorMessage(error: any) {
    const { currentUser, config } = useAppContext();
    const history = useHistory();


    const goBack = async () => {
        if (currentUser) {
            history.push('/home');
        } else {
            history.push('/login')
        }
    };

    return <>
        <div style={{ backgroundColor: 'white' }}>
            <div style={{display:'flex',width: '100%', height: '100vh', paddingTop: '5%', justifyContent: "center"}}>
                {/* <div className='err-main-logo'></div> */}
                <div className='err-main-container'>
                    <div className='err-main-heading'>
                        Sorry!<br></br>
                        {"It looks like you’ve found a bug."}
                    </div>
                    <div className='err-sub-heading'>
                        {error.message.data ? error.message.data : 'notfound'}
                    </div>
                    <button className='take-me-button' onClick={goBack}>
                        Go back
                    </button>
                </div>
            </div>
            <div className='BeaconFabButtonFrame'></div>
        </div>
    </>
}

export default ErrorMessage;
